import React, { useState } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { raiseSignoffTicketMilestone } from '../../../actions/service_request';
import { RemarkForm } from '../../Payments/Modals/EditPayout/EditPayoutTable';
import RenderMilestones from '../components/RenderMileStones';

export default function RaisePavSignOff({ ticket, milestones }) {
    const dispatch = useDispatch();
    const [selectedMilestone, setSelectedMilestone] = useState(milestones?.[0]?.id);
    const formName = `pav_raise_signoff_${selectedMilestone || 'milestone'}`;

    const submit = ({ processed_remark, closing_at }) => {
        if (!selectedMilestone) return;

        const payload = { closed_at: moment(closing_at).format('YYYY-MM-DDTHH:mm:ss.SSSZ') };
        if (processed_remark?.value) {
            payload.closed_remark = processed_remark.label;
            if (!processed_remark.value.startsWith('create_this_issue')) {
                payload.master_remark_id = processed_remark.value;
            }
        }

        dispatch(raiseSignoffTicketMilestone({
            payload,
            formName,
            ticketId: ticket?.id || ticket?.ticket_id,
            milestoneId: selectedMilestone,
        }));
    };

    return (
        <div className='p-4'>
            <div className='mb-2'>
                <p className='mb-2 text-font11 font-medium text-scogo21'>Select PAV milestone</p>
                <RenderMilestones
                    milestones={milestones}
                    selectedMilestones={selectedMilestone}
                    setSelectedMilestones={setSelectedMilestone}
                />
            </div>
            <RemarkForm
                helpdesk_id={ticket?.helpdesk_id}
                category='SIGN_OFF'
                formName={formName}
                onClick={submit}
                showClosingDate
                org_id={ticket?.org_id}
            />
        </div>
    );
}
